import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { DeepLinkService } from '../services/deep-link.service';
import { AppStateService } from '../services/app-state.service';

export const authGuard: CanMatchFn = async (route, segments) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const deepLinkService = inject(DeepLinkService);
  const appState = inject(AppStateService);

  const isLoggedIn = authService.isLoggedIn();

  // ── Not authenticated – redirect immediately, no need to wait for hydration ──
  if (!isLoggedIn) {
    // Capture the attempted URL so the user can be redirected back after login.
    const currentNav = router.getCurrentNavigation();
    const attemptedUrl = currentNav?.initialUrl?.toString() ?? window.location.pathname + window.location.search;
    if (attemptedUrl && attemptedUrl !== '/auth') {
      deepLinkService.setDeepLink(attemptedUrl);
    }
    return router.createUrlTree(['/auth']);
  }

  // ── Authenticated – wait for the app to be fully hydrated ──
  await appState.whenHydrated();

  // Re‑check auth status in the very rare case it changed during hydration
  return authService.isLoggedIn() ? true : router.createUrlTree(['/auth']);
};
